import { digObject } from '@domain-group/javascript-utils'

import { DashboardModule, Form } from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

interface ExternalFTPProps {
  portalFormPayload: UseFormPayload,
}

const ExternalFTP = (props: ExternalFTPProps) => {
  const { portalFormPayload } = props

  const { entityState, handlers } = portalFormPayload

  const externalFTP = digObject(entityState, 'external_ftp', {})
  const {
    host,
    password,
    path,
    port,
    username,
  } = externalFTP

  return (
    <DashboardModule title="External FTP">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Host">
            <input
              name="external_ftp.host"
              type="text"
              value={host}
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Port" marginTop={['large', 0]}>
            <input
              name="external_ftp.port"
              type="text"
              value={port}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Path">
            <input
              name="external_ftp.path"
              type="text"
              value={path}
              {...handlers}
            />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Username" marginTop={['large', 0]}>
            <input
              name="external_ftp.username"
              type="text"
              value={username}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Password">
            <input
              name="external_ftp.password"
              type="text"
              value={password}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default ExternalFTP
